module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-blog-2-9d72b4876738aae5446b4b533246f502.jpg";